<template>
  <div class="container">
    <BreadcrumbGroup v-if="!isAuWallet()" :items="breadcrumbItems" />

    <HeadingOne class="-margin-md">暗証番号の再設定</HeadingOne>

    <WizardGroup class="-margin-md">
      <MainWizard :active-index="1" type="userpassword"></MainWizard>
    </WizardGroup>

    <section>
      <NoticeBox class="-success">
        <NoticeHeader>
          <h3 class="heading">暗証番号の再設定が完了いたしました。</h3>
        </NoticeHeader>
        <NoticeBody
          >暗証番号は、非常に重要な情報となるため、第三者に知られることのないよう十分にご注意ください。</NoticeBody
        >
      </NoticeBox>
    </section>

    <BtngroupSingle class="-margin-lg">
      <BtnMain v-if="!isAuWallet()" class="-main" router-name="mb001">
        会員さま専用サイトトップへ
      </BtnMain>
      <BtnMain v-else class="-main" router-name="mb012">
        au PAY 残高にチャージ
      </BtnMain>
    </BtngroupSingle>
  </div>
  <!-- container -->
</template>

<script>
import { isAuWallet } from "@/utils/UserAgent";
import { setMeta } from "@/utils/Meta";
import HeadingOne from "@/components/heading/HeadingOne";
import MainWizard from "@/components/wizard/MainWizard";
import WizardGroup from "@/components/wizard/WizardGroup";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeBody from "@/components/box/NoticeBody";
import NoticeHeader from "@/components/box/NoticeHeader";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";

export default {
  name: "Mb034",
  components: {
    NoticeHeader,
    NoticeBody,
    NoticeBox,
    BtnMain,
    BtngroupSingle,
    WizardGroup,
    MainWizard,
    HeadingOne,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "暗証番号の再設定",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "暗証番号の再設定",
          active: true,
        },
      ],
    };
  },
  methods: {
    isAuWallet: function () {
      return isAuWallet();
    },
  },
};
</script>

<style scoped></style>
